import { createFileRoute } from '@tanstack/react-router';
import LazyRoute from '../components/LazyRoute';
import { SimplePageLoader } from '@/components/ui/page-loader';

export const Route = createFileRoute('/_protected/transformations/new')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/transformations/CreateTransformationForm')}
      fallback={<SimplePageLoader />}
    />
  ),
});
